import React from "react";
import axios from "axios";
import { Link } from "react-router-dom";

import './style.css';
import '../style.css'
import { API_URL, ERROR_HANDLE } from "../../../../config/constants";
import theme from "../../../../Theme/theme";
import Pagination from "../../../../components/Pagination";
import DateRangePicker from "../../../../components/DateRangePicker";
import moment from "moment-timezone";
import { Constants, TimeFormats } from "../../../../common/constants";
import SlideSwitch from "../../../../components/SlideSwitch";
import { toast } from "react-toastify";
import Select from 'react-select';

const MODE_ONGOING = 0;
const MODE_UPCOMING = 1;
const MODE_PAST = 2;

const SESSION_DATE_FORMAT = "YYYY/MM/DD";
const restricted_access = localStorage.getItem("restricted_access");

class Bookings extends React.Component {

    constructor(props) {
        super(props);
        let storedState = localStorage.getItem(Constants.STATE_VPT_BOOKINGS);
        if (storedState)
            storedState = JSON.parse(storedState);
        this.state = storedState ? storedState : {
            mode: MODE_UPCOMING,
            bookings: [],
            loading: false,
            currentPage: 0,
            countPerPage: Constants.DEFAULT_PAGINATION_COUNT,
            selected_status: []
        };
        this.toggledBookingId = null;
    }

    componentWillUnmount() {
        localStorage.setItem(Constants.STATE_VPT_BOOKINGS, JSON.stringify(this.state));
    }

    componentDidMount() {
        this.getBookings(this.state.selected_status);
    }

    getBookings = (statusArr = []) => {

        let { mode, currentPage, countPerPage, searchQuery, startDate, endDate } = this.state;

        if (restricted_access === "true" && !searchQuery) {
            this.setState({
                bookings: []
            });
            return;
        }

        const access_token = localStorage.getItem("access_token");
        this.setState({
            loading: true,
            bookings: [],
            selected_status: statusArr
        })
        let url = `${API_URL}/admin/virtualTraining/bookings?type=${mode}&cpp=${countPerPage}&index=${currentPage}`;
        url = searchQuery ? (url + "&search=" + encodeURIComponent(searchQuery)) : url
        url = startDate ? (url + "&from=" + moment(startDate).format(SESSION_DATE_FORMAT)) : url
        url = endDate ? (url + "&to=" + moment(endDate).format(SESSION_DATE_FORMAT)) : url
        url = (url + "&selected_status=" + JSON.stringify(statusArr))
        axios.get(url, {
            headers: {
                "x-access-token": access_token
            }
        }).then(res => {
            return res.data
        })
            .then(data => {
                this.setState({
                    bookings: data.data,
                    totalPages: data.pagination.total,
                    loading: false
                })
            }).catch(error => {
                this.setState({
                    loading: false
                })
                ERROR_HANDLE(error)
            })
    }

    searchHandler = e => {
        //Move the current page to 1, when start searching
        if (this.timeOut) clearTimeout(this.timeOut) // Hit api only if there is no event for 500 ms
        this.setState({
            ...this.state,
            currentPage: 0,
            searchQuery: e.target.value.toLowerCase()
        }, () => {
            this.timeOut = setTimeout(() => {
                this.getBookings(this.state.selected_status) // Hit api only if there is no event for 500 ms
                this.timeOut = null
            }, 500);
        });
    };

    switchStatus = (selectedOption) => {
        let statusArr = [];
        if (selectedOption && selectedOption.length > 0) statusArr = selectedOption.map(item => item.value);
        this.getBookings(statusArr);
    }

    render() {
        return (
            <div className="content">
                <div className="selector">
                    {this.renderTab(MODE_ONGOING, "Ongoing")}
                    {this.renderTab(MODE_UPCOMING, "Upcoming")}
                    {this.renderTab(MODE_PAST, "Past")}
                </div>
                <div className="selector">
                    <input placeholder={"Search"} value={this.state.searchQuery} onChange={this.searchHandler} style={styles.input} />
                    {this.renderDateRangePicker()}
                    <Select
                        onChange={this.switchStatus}
                        isMulti={true}
                        placeholder="Filter Status.."
                        styles={{
                            container: (base) => ({
                                ...base,
                                flexDirection: "row",
                                width: '25%',
                                margin: 60,
                            }),
                            control: (base, state) => {
                                return {
                                    ...base,
                                    boxShadow: state.isFocused ? "0 0 3px 2px rgba(0,180,210,0.38)" : 0,
                                    "&:hover": {
                                        borderColor: state.isFocused ? 'rgba(0,180,210,1)' : 'black'
                                    },
                                    border: state.isFocused ? "1px solid rgba(0,180,210,1)" : "1px solid black",
                                    borderRadius: "6px",
                                };
                            },
                            option: (base) => {
                                return {
                                    ...base,
                                    textAlign: 'start'
                                }
                            }
                        }}
                        options={Constants.USER_TRAINER_SESSION_STATUS_ARR}
                    />
                </div>
                {this.renderBookings()}
                {this.renderPaginator()}
            </div>
        )
    }

    renderDateRangePicker = () => {
        return <DateRangePicker
            style={{
                backgroundColor: 'transparent',
                flexDirection: 'row'
            }}
            lite
            horizontal
            allowFuture
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            onChangeStartDate={startDate => {
                this.setState({
                    startDate
                }, () => {
                    if (this.state.endDate) {
                        this.getBookings(this.state.selected_status)
                    }
                })
            }}
            onChangeEndData={endDate => {
                this.setState({
                    endDate
                }, () => {
                    if (this.state.startDate) {
                        this.getBookings(this.state.selected_status)
                    }
                })
            }}
            onChangeRangeFilter={(startDate, endDate) => {
                this.startDate = startDate;
                this.endDate = endDate;
                this.setState({
                    startDate: startDate,
                    endDate: endDate
                });
            }}
        />
    }

    renderPaginator = () => {
        return (
            !this.state.loading && this.state.bookings.length > 0 ?
                <Pagination
                    currentPage={this.state.currentPage}
                    pageCount={this.state.totalPages}
                    rowCount={this.state.countPerPage}
                    pageAction={pageNumber => {
                        this.setState({
                            currentPage: pageNumber,
                        }, () => {
                            this.getBookings(this.state.selected_status)
                        })
                    }}
                    updateRowCount={(rowCount) => {
                        this.setState({
                            countPerPage: rowCount,
                            currentPage: 0
                        }, () => {
                            this.getBookings(this.state.selected_status)
                        })
                    }} />
                : null
        )
    }

    renderBookings = () => {
        let { bookings, loading, searchQuery } = this.state;
        if (bookings.length > 0 && !loading) {
            return bookings.map(booking => {
                return this.renderRow(booking)
            })
        } else {
            return <div className="unselectable empty">
                {loading ? "Fetching bookings..." : (restricted_access == 'true' && !searchQuery ? "Search for results" : "No bookings")}
            </div>
        }
    }

    renderRow = (booking) => {
        return (
            <div className="booking">
                <div>
                    <img src={booking.trainerProfilePicture} style={styles.image} alt="TrainerImage" />
                    <img src={booking.userProfilePicture} style={styles.image} alt="UserImage" />
                </div>
                <div style={styles.section}>
                    <div style={styles.label}>Trainer
                        <div style={styles.name}>{booking.trainerName}</div>
                    </div>
                    <div style={styles.label}>User
                        <div style={styles.name}>{booking.userName}</div>
                    </div>
                </div>
                <div style={styles.section}>
                    <div style={styles.label}>Date
                        <div style={styles.name}>{this.getDate(booking.bookingStartTime, booking.trainerSlotTimeZone)}</div>
                    </div>
                    <div style={styles.label}>Duration
                        <div style={styles.name}>{booking.bookingDuration} min</div>
                    </div>
                </div>
                <div style={styles.section}>
                    <div style={styles.label}>Timezone
                        <div style={styles.name}>{booking.trainerSlotTimeZone}</div>
                    </div>
                    <div style={styles.label}>Source
                        <div style={styles.name}>{booking.source != null ? booking.source : "Not Set"}</div>
                    </div>
                </div>
                <div style={styles.section}>
                    <div style={styles.label}>Amount
                        <div style={styles.name}>${booking.amountPaid ? booking.amountPaid.toFixed(2) : '0.00'}</div>
                    </div>
                    <div style={styles.label}>Status
                        <div style={styles.name}>{(booking.bookingStatus == Constants.STATUS_CONFIRMED && booking.trainerStatus == Constants.STATUS_ACCEPTED) ? "CONFIRMED" : booking.bookingStatus}</div>
                    </div>
                </div>
                {this.state.mode == MODE_UPCOMING && <div style={styles.section}>
                    <div style={styles.label}>Recording Enabled</div>
                    <SlideSwitch
                        style={styles.sliderStyle}
                        checked={booking.is_recording_enabled}
                        onClick={() => {
                            this.toggledBookingId = booking.bookingId;
                            this.handleToggledBooking(!booking.is_recording_enabled);
                        }}
                    />
                </div>
                }
                <Link to={{
                    pathname: "/vpt/booking/" + booking.bookingId,
                    state: {
                        booking: booking,
                        isUpcoming: this.state.mode == MODE_UPCOMING
                    }
                }}>
                    <button className="unselectable" style={styles.action}>
                        View
                    </button>
                </Link>
            </div>
        )
    }

    handleToggledBooking = (activeState) => {
        if (this.toggledBookingId) {
            //Update local
            this.updateToggleState(this.toggledBookingId);
            //Update through API
            this.updateRecordingStatusOfBooking(activeState);
        }
    };

    updateToggleState(toggledBookingId) {
        this.setState(prevState => ({
            bookings: prevState.bookings.map(
                booking => booking.bookingId === toggledBookingId ? { ...booking, is_recording_enabled: !booking.is_recording_enabled } : booking
            )
        }))
    }

    //To update the recording status of booking
    updateRecordingStatusOfBooking = (activeState) => {
        var toastId = toast("Updating details...")
        axios.put(`${API_URL}/trainer/slot/user/bookings/toggle_recording/${this.toggledBookingId}`,
            { is_recording_enabled: activeState },
            {
                headers: {
                    "x-access-token": localStorage.getItem("access_token")
                }
            }).then((res) => {
                toast.dismiss(toastId);
                toast("Recording Status Changed Successfully", { autoClose: 1500 });
                this.toggledBookingId = null;
            }).catch((e) => {
                this.updateToggleState(this.toggledBookingId);
                this.toggledBookingId = null;
                toast.dismiss(toastId);
                ERROR_HANDLE(e);
            })
    }

    renderTab = (modeId, title) => {
        let { mode } = this.state;
        return <div className={`unselectable sessions-tab ${mode == modeId ? "sessions-tab-active" : ""}`}
            onClick={() => {
                if (mode != modeId) {
                    this.setState({
                        mode: modeId,
                        currentPage: 0
                    }, () => {
                        this.getBookings(this.state.selected_status)
                    })
                }
            }}>
            {title}
        </div>
    }

    getDate = (time, timeZone) => {
        return moment(time, TimeFormats.bookingTimeFormat).tz(timeZone).format("MMM DD, YYYY, hh:mm a")
    }

    getTime = (time, timeZone) => {
        return moment(time, TimeFormats.bookingTimeFormat).tz(timeZone).format("hh:mm a")
    }
}

export default Bookings;

const styles = {
    section: {
        flexDirection: 'row',
        flex: 1
    },
    label: {
        display: 'flex',
        flexDirection: 'row',
        textAlign: "start",
        fontFamily: theme.font.glacialIndifference,
        fontSize: 16,
        marginLeft: 10,
        color: theme.color.black,
        alignItems: 'baseline'
    },
    name: {
        color: theme.color.teal,
        marginLeft: 10
    },
    image: {
        height: 60,
        width: 60,
        borderRadius: 30,
        marginLeft: 15,
        marginRight: 15
    },
    action: {
        margin: 30,
        backgroundColor: theme.color.teal,
        color: theme.color.white,
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 5,
        paddingBottom: 5,
        borderRadius: 5
    },
    input: {
        display: 'flex',
        width: '30%',
        margin: 20,
        padding: 15,
        paddingLeft: 30,
        paddingRight: 30,
        backgroundColor: 'transparent',
        color: theme.color.teal,
        borderWidth: 0,
        borderRadius: 5,
        boxShadow: "2px 2px 4px 0 #D1D9E6, -2px -2px 4px 0 #D1D9E6"
    },
    sliderStyle: {
        marginTop: 5,
        minWidth: 75,
        display: 'flex',
        marginLeft: 10,
    },
}